import { Container } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import { DossierAddFormality } from '../../components';

const AddFormality: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    if (!idDossier) {
        console.warn(`Dossier non trouvé paramètres url:  ${idDossier}`);
        throw new Error(`Dossier non trouvé paramètres url:  ${idDossier}`);
    }
    return (
        <Container maxWidth="md">
            <DossierAddFormality />
        </Container>
    );
};

export default AddFormality;
